import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MdMenuOpen, MdOutlineMenu } from 'react-icons/md';
import { CiLight } from 'react-icons/ci';
import { FaWallet, FaBell, FaMoon } from 'react-icons/fa';
import { CgSearch } from "react-icons/cg";
import { useMyContext } from '../../../context/MyContext';
import { toast } from 'react-hot-toast'
import { useAuth } from '../../../routes/Auth';
import TrackingSidePopup from '../../b2c/../../B2C/pages/dashborad/TrackingSidePopup';
import {
  Base_Url,
  userdata,
  Url_For_View_Document,
  readnotification,
  forwardorderlistall,
  payment,
  notification,
  grandTotalAmount
} from '../../../config/config';

const NavBar = () => {
  const {
    isB2BMode,
    setIsToggleSidebar,
    toggleB2BMode,
    isToggleSidebar,
    isDarkMode,
    toggleTheme,
    setorderId,
    setIsDarkMode } = useMyContext();
  const navigate = useNavigate();
  const notificationMenuRef = useRef(null);
  const [walletMenuVisible, setWalletMenuVisible] = useState(false);
  const walletMenuRef = useRef(null);
  const [isSearching, setIsSearching] = useState(false);
  const userMenuRef = useRef(null);
  const [userData, setUserData] = useState([]);
  const [userName, setUserName] = useState("");
  const [userMenu, setUserMenu] = useState(false);
  const { logout } = useAuth()
  const user = JSON.parse(localStorage.getItem('user'));
  const [orderIdInput, setOrderIdInput] = useState('');
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');
  const [profile, setProfile] = useState()
  const [notificationMenuVisible, setNotificationMenuVisible] = useState(false);
  const [currentBalanace, setCurrentBalanace] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const profile_flag = localStorage.getItem('profile_flag');
  const [showTrackingPopup, setShowTrackingPopup] = useState(false);

  useEffect(() => {

    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser && storedUser.userData.name) {
      setUserName(storedUser.userData.name);
    }
    if (role === "admin") {
      getTotalAmount();
    }
    getPayment();
  }, []);

  useEffect(() => {
    fetchUserData();
    fetchNotifications();
  }, [cus_id, token]);

  const fetchNotifications = async () => {
    const url = Base_Url + notification;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json',
        },
      });
      const result = await response.json();

      if (result.status === "SUCCESS") {
        setNotifications(result.data);
        const unread = result.data.filter(notif => notif.is_read === "0").length;
        setUnreadCount(unread);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const fetchUserData = async () => {
    const url = Base_Url + userdata;
    if (cus_id) {
      try {
        const response = await fetch(url + "/" + cus_id, {
          method: 'GET',
          headers: {
            'token': token,
            'cus_id': cus_id,
            'Content-Type': 'application/json',
          },
        });
        const result = await response.json();
        setUserData(result.data);
        const profile = result.data.profile_image
          ? Url_For_View_Document + result.data.profile_image
          : null;
        setProfile(profile);
        if (result.data.name) {
          setUserName(result.data.name);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    }
  };

  const toggleWalletMenu = () => {
    const walletStatus = user.userData.wallet_status;

    if (walletStatus === "1") {
      setWalletMenuVisible(!walletMenuVisible);
    }
  };

  const toggleNotificationMenu = () => {
    setNotificationMenuVisible(!notificationMenuVisible);
  };

  const toggleUserMenu = () => {
    setUserMenu(!userMenu);
  }

  const goToTopUp = () => {
    navigate('/payments/walletbalance');
  };

  const navigation = () => {
    if (profile_flag === "1") {
      navigate('/profile');
    }
  }

  const handleLogout = () => {
    localStorage.removeItem("user");
    document.documentElement.classList.remove('dark');
    setIsDarkMode(false);
    navigate('/login')
    logout()
    localStorage.removeItem('cus_id')
    localStorage.removeItem('token')
    localStorage.removeItem("wallet_status");
    localStorage.removeItem("profile_flag");
    localStorage.removeItem("role");
    localStorage.removeItem("isB2BMode");
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (walletMenuRef.current && !walletMenuRef.current.contains(event.target)) {
        setWalletMenuVisible(false);
      }
      else if (notificationMenuRef.current && !notificationMenuRef.current.contains(event.target)) {
        setNotificationMenuVisible(false);
        handleDeleteNotification();
        fetchNotifications();
      }
      else if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [walletMenuRef, userMenuRef, notificationMenuRef, setWalletMenuVisible, setNotificationMenuVisible, setUserMenu]);


  const handleSearchKeyDown = async (event) => {
    if (event.key === 'Enter') {
      const trimmedInput = orderIdInput.trim();
      if (!trimmedInput) {
        toast.error('Please enter a valid Order ID');
        return;
      }
      setIsSearching(true);
      setorderId(trimmedInput);
      setTimeout(() => navigate('/shipments/tracking'), 100);
      setIsSearching(false);

    }
  };


  const handleDeleteNotification = async () => {
    const urldelete = Base_Url + readnotification;

    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');

      const response = await fetch(urldelete, {
        method: "GET",
        headers: {
          "token": token,
          "cus_id": cusid,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data.status === "SUCCESS") {
      } else {
      }
    } catch (error) {
    }
  };

  const getPayment = async () => {
    const url = Base_Url + payment
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        setCurrentBalanace(data.totalamount);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };


  const getTotalAmount = async () => {
    const uri = Base_Url + "admin/" + grandTotalAmount;

    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');

      const response = await fetch(uri, {
        method: "GET",
        headers: {
          "token": token,
          "cus_id": cusid,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.status === "SUCCESS") {
        setTotalAmount(data.grand_total);
      } else {
        console.error("Error:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };


  const NotificationMenu = () => (
    <div
      ref={notificationMenuRef}
      className="absolute right-0 mt-3 w-80 bg-white/95 dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] backdrop-blur-xl border border-gray-100 dark:border-indigo-500/30 rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.12)] dark:shadow-[0_10px_40px_rgba(79,70,229,0.35)] z-50 max-h-96 overflow-y-auto overflow-hidden"
    >
      <div className="px-4 py-3.5 border-b border-gray-100 dark:border-indigo-500/20 sticky top-0 bg-white/95 dark:bg-[#0b0b14]/95 backdrop-blur-xl">
        <h3 className="text-[15px] font-semibold text-gray-800 dark:text-white">Notifications</h3>
      </div>
      {notifications.length === 0 ? (
        <div className="p-6 text-center text-sm text-gray-400 dark:text-indigo-300/60">
          No notifications
        </div>
      ) : (
        <ul className="divide-y divide-gray-100 dark:divide-indigo-500/15">
          {notifications.map((notification) => (
            <li
              key={notification.id}
              className={`px-4 py-3 hover:bg-gray-50 dark:hover:bg-indigo-500/10 transition-colors duration-200 cursor-pointer ${notification.is_read === "0" ? 'bg-blue-50/60 dark:bg-indigo-500/15' : ''
                }`}
            >
              <div className="flex flex-col gap-0.5">
                <span className="font-semibold text-[13px] text-gray-800 dark:text-indigo-100">
                  {notification.title}
                </span>
                <span className="text-[12.5px] text-gray-500 dark:text-indigo-200/70 leading-snug">
                  {notification.message}
                </span>
                <span className="text-[11px] text-gray-400 dark:text-indigo-300/50 mt-1">
                  {new Date(notification.created_at).toLocaleString()}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  const handleInputChange = (event) => {
    const { value, id } = event.target;
    if (['orderId'].includes(id)) {
      const filteredValue = value.replace(/[^0-9]/g, '');
      event.target.value = filteredValue;
      setOrderIdInput(filteredValue);
      if (filteredValue) {
        setShowTrackingPopup(true);
      } else {
        setShowTrackingPopup(false);
      }
    }
  };


  const SwitchIcon = ({ isOn, onToggle }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="24"
        viewBox="0 0 40 22"
        onClick={onToggle}
        className="cursor-poniter transition-colors duration-300"
      >
        <rect
          x="1"
          y="1"
          rx="11"
          ry="11"
          width="38"
          height="20"
          className={`transition-colors duration-300 ${isOn ? "fill-blue-500" : "fill-gray-400"
            }`}
        />

        {!isOn && (
          <text
            x="29"
            y="12"
            textAnchor="middle"
            dominantBaseline="middle"
            className="fill-white text-xs font-medium pointer-events-none select-none"
            style={{ fontSize: '7px' }}
          >
            B2C
          </text>
        )}

        <circle
          cx={isOn ? "29" : "11"}
          cy="11"
          r="8"
          className="fill-white transition-all duration-300"
        />
      </svg>
    );
  };

  const switchToB2B = () => {
    toggleB2BMode(!isB2BMode);

    if (!isB2BMode) {
      navigate("/b2b/dashboard");
      window.location.reload();
    } else {
      navigate("/dashboard");
    }
  };
  return (
    <div className="flex items-center justify-between gap-3 px-3 md:px-5 h-16 md:h-[68px] md:py-0 relative bg-white dark:bg-gradient-to-r dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] border-b border-white/40 dark:border-indigo-500/25 dark:shadow-[0_4px_30px_rgba(79,70,229,0.15)]">
      {/* ===== LOGO + SIDEBAR TOGGLE ===== */}
      <div className="flex items-center flex-shrink-0">
        <Link to="/dashboard">
          <div className="flex items-center cursor-pointer">
            <img src="/assets/images/logo1.png" alt="Logo" className="w-[60px] h-[40px] sm:w-[110px] sm:h-[46px] lg:w-[170px] lg:h-[80px] object-contain" />
          </div>
        </Link>
        <button
          onClick={() => setIsToggleSidebar(!isToggleSidebar)}
          className="ml-4 md:ml-6 w-9 h-9 flex items-center justify-center rounded-xl text-blue-600 dark:text-indigo-300 bg-white/40 dark:bg-indigo-500/10 border border-white/50 dark:border-indigo-500/30 backdrop-blur-md shadow-sm hover:bg-white/70 dark:hover:bg-indigo-500/20 hover:scale-105 transition-all duration-200 dark:shadow-[0_0_15px_rgba(99,102,241,0.2)]"
        >
          {isToggleSidebar === false ? <MdMenuOpen size={20} /> : <MdOutlineMenu size={20} />}
        </button>
      </div>

      {/* ===== SEARCH BAR ===== */}
      <div className="flex-grow max-w-2xl mx-1 md:mx-6 order-3 md:order-2">
        <div className="relative flex items-center ml-28 bg-white/60 dark:bg-[#1a1a2e]/80 backdrop-blur-md rounded-xl w-[350px] shadow-[inset_0_1px_2px_rgba(0,0,0,0.04)] dark:shadow-[inset_0_1px_2px_rgba(0,0,0,0.4)] border border-white/50 dark:border-indigo-500/40 focus-within:border-blue-400 dark:focus-within:border-indigo-400 dark:focus-within:shadow-[0_0_20px_rgba(99,102,241,0.4)] transition-all duration-200">
          <CgSearch className={`absolute left-3.5 ${isDarkMode ? "text-indigo-300" : "text-custom-gray"}`} size={18} />
          <input
            disabled={isSearching}
            type="text"
            id='orderId'
            value={orderIdInput}
            onChange={handleInputChange}
            onKeyDown={handleSearchKeyDown}
            placeholder="Search with Order ID or LR Number"
            className={`w-[350px] font-sans bg-transparent h-[42px] border border-gray-400/40 dark:border-transparent outline-none rounded-xl pl-11 pr-10 text-[13px] placeholder:text-[13px] ${isDarkMode ? "placeholder-indigo-300/50 text-white" : "placeholder-custom-gray"} ${isSearching ? 'cursor-not-allowed opacity-50' : ''}`}
          />
          {isSearching && <div className="absolute right-4 animate-spin text-sm">🔄</div>}
        </div>
      </div>

      {/* ===== RIGHT ACTIONS ===== */}
      <div className="flex items-center gap-1.5 lg:gap-3 order-2 md:order-3 flex-shrink-0">

        {/* B2B/B2C Switch */}
        <div className="relative group flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="30"
            viewBox="0 0 60 32"
            onClick={switchToB2B}
            className="cursor-pointer transition-all duration-300 hover:scale-105 filter hover:drop-shadow-md"
          >
            <defs>
              <linearGradient id="onGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style={{ stopColor: '#3B82F6', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#1D4ED8', stopOpacity: 1 }} />
              </linearGradient>
              <linearGradient id="offGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style={{ stopColor: '#9CA3AF', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#6B7280', stopOpacity: 1 }} />
              </linearGradient>
            </defs>

            <rect
              x="2"
              y="2"
              rx="14"
              ry="14"
              width="56"
              height="28"
              fill={isB2BMode ? "url(#onGradient)" : "#E5E7EB"}
              className="transition-all duration-300"
            />

            {!isB2BMode && (
              <text
                x="42"
                y="17"
                textAnchor="middle"
                dominantBaseline="middle"
                className="font-bold pointer-events-none select-none"
                style={{ fontSize: '10px', fontFamily: 'system-ui', fill: '#60A5FA' }}
              >
                B2C
              </text>
            )}
            {isB2BMode && (
              <text
                x="18"
                y="17"
                textAnchor="middle"
                dominantBaseline="middle"
                className="fill-white font-bold pointer-events-none select-none"
                style={{ fontSize: '10px', fontFamily: 'system-ui' }}
              >
                B2B
              </text>
            )}

            <circle
              cx={isB2BMode ? "44" : "16"}
              cy="16"
              r="11"
              className="fill-white transition-all duration-300 filter drop-shadow-md"
            />

            <circle
              cx={isB2BMode ? "44" : "16"}
              cy="16"
              r="8"
              className="fill-white transition-all duration-300"
            />
          </svg>

          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-[11px] bg-gray-800 text-white dark:bg-indigo-950 dark:text-indigo-100 dark:border dark:border-indigo-500/40 px-2.5 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50 shadow-lg">
            {isB2BMode ? "Switch to B2C" : "Switch to B2B"}
          </span>
        </div>

        {/* Theme Toggle Button */}
        <div className="relative group">
          <button
            onClick={toggleTheme}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-white/30 dark:bg-indigo-500/10 border border-white/40 dark:border-indigo-500/30 backdrop-blur-md transition-all duration-300 hover:bg-white/60 dark:hover:bg-indigo-500/20 hover:scale-105 focus:outline-none shadow-sm dark:shadow-[0_0_15px_rgba(99,102,241,0.2)]"
          >
            {isDarkMode ?
              <CiLight size={22} className="text-indigo-300 transition-colors duration-300" /> :
              <FaMoon size={19} className="text-blue-500 transition-colors duration-300" />
            }
          </button>
          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-[11px] bg-gray-800 text-white dark:bg-indigo-950 dark:text-indigo-100 dark:border dark:border-indigo-500/40 px-2.5 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50 shadow-lg">
            {isDarkMode ? "Light Mode" : "Dark Mode"}
          </span>
        </div>

        {/* Wallet Button */}
        <div className="relative group">
          <button
            onClick={toggleWalletMenu}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-white/30 dark:bg-indigo-500/10 border border-white/40 dark:border-indigo-500/30 backdrop-blur-md transition-all duration-300 hover:bg-white/60 dark:hover:bg-indigo-500/20 hover:scale-105 focus:outline-none shadow-sm dark:shadow-[0_0_15px_rgba(99,102,241,0.2)]"
            aria-label="Toggle wallet menu"
          >
            <FaWallet size={19} className={`transition-colors duration-300 ${isDarkMode ? "text-indigo-300" : "text-blue-500"}`} />
          </button>

          {walletMenuVisible && (
            <div
              ref={walletMenuRef}
              className="absolute right-0 mt-3 w-60 bg-white/95 dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] backdrop-blur-xl border border-gray-100 dark:border-indigo-500/30 rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.12)] dark:shadow-[0_10px_40px_rgba(79,70,229,0.35)] z-50 transition-all duration-200 ease-in-out overflow-hidden"
            >
              <ul className="text-gray-700 dark:text-indigo-100 divide-y divide-gray-100 dark:divide-indigo-500/15">
                <li className="py-3 px-4 cursor-default flex items-center justify-between text-[13px]">
                  <span className="text-gray-500 dark:text-indigo-300/70">Balance</span>
                  {role !== "admin" ? (
                    <span className="font-semibold dark:text-white">₹ {currentBalanace}</span>
                  ) : (
                    <span className="font-semibold dark:text-white">₹ {totalAmount}</span>
                  )}
                </li>
                <li
                  className="py-3 px-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-indigo-500/15 transition-colors duration-200 flex items-center justify-between text-[13px] font-medium"
                  onClick={goToTopUp}
                >
                  <span>Top-Up</span>
                  <span className="text-gray-300 dark:text-indigo-300/50">›</span>
                </li>
              </ul>
            </div>
          )}
          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-[11px] bg-gray-800 text-white dark:bg-indigo-950 dark:text-indigo-100 dark:border dark:border-indigo-500/40 px-2.5 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50 shadow-lg">
            Wallet
          </span>
        </div>

        {/* Notification Button */}
        <div className="relative group">
          <button
            onClick={toggleNotificationMenu}
            className="relative w-10 h-10 flex items-center justify-center rounded-full bg-white/30 dark:bg-indigo-500/10 border border-white/40 dark:border-indigo-500/30 backdrop-blur-md transition-all duration-300 hover:bg-white/60 dark:hover:bg-indigo-500/20 hover:scale-105 focus:outline-none shadow-sm dark:shadow-[0_0_15px_rgba(99,102,241,0.2)]"
            aria-label="Toggle notification menu"
          >
            <FaBell
              size={19}
              className={`transition-all duration-300 ${isDarkMode ? "text-indigo-300" : "text-blue-500"}`}
            />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-semibold rounded-full h-5 w-5 flex items-center justify-center ring-2 ring-white dark:ring-[#0b0b14] animate-pulse dark:shadow-[0_0_10px_rgba(239,68,68,0.6)]">
                {unreadCount}
              </span>
            )}
          </button>
          {notificationMenuVisible && <NotificationMenu />}
          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-[11px] bg-gray-800 text-white dark:bg-indigo-950 dark:text-indigo-100 dark:border dark:border-indigo-500/40 px-2.5 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50 shadow-lg">
            Notifications
          </span>
        </div>

        {/* User Profile Button */}
        <div className="relative group ml-1">
          <button
            onClick={toggleUserMenu}
            className="hidden lg:flex items-center gap-2.5 pl-1.5 pr-3 py-1.5 rounded-full bg-white/30 dark:bg-indigo-500/10 border border-white/40 dark:border-indigo-500/30 backdrop-blur-md transition-all duration-300 hover:bg-white/60 dark:hover:bg-indigo-500/20 hover:scale-[1.02] focus:outline-none shadow-sm dark:shadow-[0_0_15px_rgba(99,102,241,0.2)]"
          >
            <div className="relative">
              {profile ? (
                <img
                  src={profile}
                  alt="Profile picture"
                  className={`w-9 h-9 rounded-full object-cover border-2 shadow-md transition-all duration-300 ${isDarkMode ? "border-indigo-400/50 dark:shadow-[0_0_15px_rgba(99,102,241,0.4)]" : "border-white"}`}
                />
              ) : (
                <div
                  className={`w-9 h-9 rounded-full border-2 shadow-md flex items-center justify-center text-white font-bold text-[13px] transition-all duration-300 bg-red-500 ${isDarkMode ? "border-indigo-400/50 dark:shadow-[0_0_15px_rgba(99,102,241,0.4)]" : "border-white"}`}
                >
                  {userName ? userName.slice(0, 2).toUpperCase() : "NA"}
                </div>
              )}
              <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 border-2 border-white dark:border-[#0b0b14] rounded-full animate-pulse"></span>
            </div>
            <span
              className={`text-[13px] font-semibold transition-colors duration-300 max-w-[110px] truncate ${isDarkMode ? "text-white glow" : "text-gray-800"}`}
            >
              {userName}
            </span>
          </button>

          {userMenu && (
            <div
              ref={userMenuRef}
              className="absolute top-full right-0 mt-3 w-36 bg-white/95 dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] backdrop-blur-xl border border-gray-100 dark:border-indigo-500/30 rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.12)] dark:shadow-[0_10px_40px_rgba(79,70,229,0.35)] z-[999] transition-all duration-200 ease-in-out overflow-hidden"
            >
              <ul className="text-gray-700 dark:text-indigo-100 divide-y divide-gray-100 dark:divide-indigo-500/15 text-[13px]">
                <li
                  onClick={navigation}
                  className="py-2.5 px-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-indigo-500/15 transition-colors duration-200 font-medium"
                >
                  Profile
                </li>
                <li
                  onClick={handleLogout}
                  className="py-2.5 px-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-red-500/15 transition-colors duration-200 font-medium text-red-500 dark:text-red-400"
                >
                  Logout
                </li>
              </ul>
            </div>
          )}

          <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 text-[11px] bg-gray-800 text-white dark:bg-indigo-950 dark:text-indigo-100 dark:border dark:border-indigo-500/40 px-2.5 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-50 shadow-lg">
            Profile
          </span>
        </div>
      </div>

      <TrackingSidePopup
        isOpen={showTrackingPopup}
        onClose={() => setShowTrackingPopup(false)}
        searchTerm={orderIdInput}
        setSearchTerm={setOrderIdInput}
        isDarkMode={isDarkMode}
      />

    </div>
  );
};
export default NavBar;